<div class="page">

  <div class="bg"></div>

  <div class="card">

    <div class="logo">
      <img src="assets/icons/launchericon-512x512.png" alt="Akıllı Yoklama">
    </div>

    <h1>Akıllı Yoklama Sistemi</h1>

    <p class="desc">
      Bu sistem web tabanlı çalışır. İstersen uygulama gibi cihazına yükleyerek daha hızlı erişim sağlayabilirsin.
    </p>

    <div class="info-box">
      <div class="info-title">📌 Web Uygulama Nedir?</div>
      <div class="info-text">
        Tarayıcı üzerinden çalışan, ancak istersen “uygulama gibi” cihazına kurulabilen modern sistemdir.
      </div>
    </div>

    <div class="features">
      <div class="feature">⚡ Anında erişim</div>
      <div class="feature">📶 Offline kullanım</div>
      <div class="feature">🔔 Bildirim desteği</div>
      <div class="feature">📱 Uygulama gibi kullanım</div>
    </div>

    <div class="actions">

      <button class="btn primary"
              (click)="installApp()"
              [disabled]="!deferredPrompt">
        📲 Uygulamayı Yükle
        <span>(Önerilen)</span>
      </button>

      <button class="btn secondary"
              (click)="continueWeb()">
        🌐 Giriş Yap
      </button>

    </div>

    <div class="footer">
      <small>Akıllı Yoklama • Ankara Üniversitesi</small>
    </div>

  </div>

</div>
